import utils from 'utils'
class collectRecordCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService, exportSettingService, getOvatAmtService, $state, $filter, $stateParams) {
        $scope.invoiceSource =$stateParams.invoiceSource //1-销项归集，2-进项归集
        $scope.treeConfig = {
            check: {
                //如果没有设置配置项，取默认配置
                enable: true, //显示不显示复选框
                chkboxType: { Y: '', N: '' },
            },
        }
        $scope.searchData = {
            orgArr: [$scope.userInfo.org],
        }
        const nowDate = new Date()
        let nowYears = nowDate.getFullYear()
        let nowMoths = nowDate.getMonth()
        let _nowDate = new Date(nowYears, nowMoths, 1) //本月第一天

        const aMonth = {
            start: $filter('date')(_nowDate, 'yyyy-MM-dd'),
            end: $filter('date')(nowDate, 'yyyy-MM-dd'),
        }
        $scope.taskTypeDict = [{enumCode:'1',enumName:'发票同步'},{enumCode:'2',enumName:'发票下载'},{enumCode:'3',enumName:'补充采集'},{enumCode:'4',enumName:'增量采集'},{enumCode:'5',enumName:'进度查询'}]
        $scope.taskResultDict =  [{enumCode:'1',enumName:'成功'},{enumCode:'2',enumName:'失败'}]
        $scope.channelTypeDict =  [{enumCode:'1',enumName:'全票通'},{enumCode:'2',enumName:'管理平台'},{enumCode:'3',enumName:'乐企直连'}]
        $scope.param = {
            param: {
                taskType: '',
                requestDateEnd: aMonth.end,
                requestDateBegin: aMonth.start,
                orgIds: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                taskResult: '',
                invoiceCode: '',
                invoiceNumber: '',
            },
            pageNum: 1,
            pageSize: 10,
            orderMap: {},
        }

        $scope.reset = function () {
            $scope.param.param = {
                taskType: '',
                requestDateEnd: aMonth.end,
                requestDateBegin: aMonth.start,
                orgIds: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                selectedOrgs: [$scope.userInfo.org],
                taskResult: '',
                invoiceCode: '',
                invoiceNumber: '',
            }
            getOrgList()
        }
        $scope.orgList = []
        function getOrgList() {
            httpRequest.get_getUserOrgList().then((res) => {
                $scope.orgList = res.data.value
                $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                    if (ele.orgId === $scope.userInfo.org.orgId) {
                        ele.checked = true
                    }
                })
            })
        }
        $scope.orderMap = {}
        $scope.customizedConfig = {
            version: 1.12,
            table: [
                {
                    //0
                    label: 'id',
                    selected: false,
                    default: false,
                },
                {
                    label: '公司名称',
                    selected: true,
                    default: true,
                },
                {
                    //5
                    label: '任务类型',
                    selected: true,
                    default: true,
                },
                {
                    label: '归集方式',
                    selected: false,
                    default: false,
                },
                {
                    label: '接口编码',
                    selected: false,
                    default: false,
                },
                {
                    label: '接口名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '请求时间',
                    selected: true,
                    default: true,
                },
                {
                    //10
                    label: '请求参数',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票代码',
                    selected: false,
                    default: false,
                },
                {
                    label: '发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '响应时间',
                    selected: false,
                    default: false,
                },
                {
                    label: '执行结果',
                    selected: true,
                    default: true,
                },
                {
                    label: '响应编码',
                    selected: true,
                    default: true,
                },
                {
                    label: '响应描述',
                    selected: false,
                    default: false,
                },
                {
                    label: '创建日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '更新时间',
                    selected: false,
                    default: false,
                },
            ],
        }
        function queryList(msg) {
            $scope.param.param.invoiceOrgIdList = $scope.param.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            const openLoading = window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            if($scope.invoiceSource === '1'){
                httpRequest
                    .post_queryOvatCollectRecord($scope.param)
                    .then((res) => {
                        $scope.collectList = res.data.value.list
                        $scope.totalItems = res.data.value.total
                        $scope.param.pageNum = res.data.value.pageNum
                    })
                    .finally(() => {
                        window.layer.close(openLoading)
                        if (msg) {
                            logger.logSuccess(msg)
                        }
                    })
            }else{
                httpRequest
                    .post_queryIvatCollectRecord($scope.param)
                    .then((res) => {
                        $scope.collectList = res.data.value.list
                        $scope.totalItems = res.data.value.total
                        $scope.param.pageNum = res.data.value.pageNum
                    })
                    .finally(() => {
                        window.layer.close(openLoading)
                        if (msg) {
                            logger.logSuccess(msg)
                        }
                    })
            }
        }
        $scope.search = function () {
            sessionStorage.setItem('collectRecordParam', JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () {
            // 点击页码发起查询
            sessionStorage.setItem(
                'collectRecordParam',
                JSON.stringify({
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: sessionStorage.collectRecordParam
                        ? JSON.parse(sessionStorage.collectRecordParam).param
                        : {
                            taskType: '',
                            requestDateEnd: aMonth.end,
                            requestDateBegin: aMonth.start,
                            orgIds: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                            selectedOrgs: [$scope.userInfo.org],
                            taskResult: '',
                            invoiceCode: '',
                            invoiceNumber: '',
                          },
                })
            )
            queryList()
        }
        $scope.goBack = function () {
            if($scope.invoiceSource === '1'){
                $state.go('outputManage.invoicePool.outputInvoicePool.list')
            }else {
                $state.go('input.invoicePool.inputInvoicePool.list')
            }
        }
    }
}

collectRecordCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService', 'exportSettingService', 'getOvatAmtService', '$state', '$filter', '$stateParams']
export default collectRecordCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/collectRecordCtrl.js